import React from "react";
import { whoLabel } from "../../../../services/workflowService";

// A workflow drawn as a line of steps, so a vendor sees what it does at a glance:
//   Name · who   →  follows the previous step
//   +            the step happens at the same time as the previous one
//   dashed chip  an optional step
//   ★            the service provider step: whoever completes the service
// Used on the workflow cards, the starter gallery and live inside the builder.
const chipStyle = (optional) => ({
  display: "inline-flex",
  alignItems: "baseline",
  gap: "4px",
  padding: "4px 10px",
  borderRadius: "14px",
  fontSize: "12px",
  background: optional ? "#fff" : "#FDE7EF",
  color: "#374151",
  border: optional ? "1px dashed #C2185B" : "1px solid #F5C2D3",
  whiteSpace: "nowrap",
});

const sepStyle = { color: "#9CA3AF", fontWeight: 700, fontSize: "13px", padding: "0 2px" };

export default function FlowPreview({ steps, skills, resourceLabel, showLegend }) {
  if (!steps?.length) return null;
  return (
    <div>
      <div className="d-flex flex-wrap align-items-center" style={{ gap: "6px" }} data-testid="flow-preview">
        {steps.map((s, i) => (
          <React.Fragment key={s._id ?? s.step_key ?? i}>
            {i > 0 && (
              <span style={sepStyle} aria-label={s.mode === "PARALLEL" ? "at the same time" : "then"}>
                {s.mode === "PARALLEL" ? "+" : "→"}
              </span>
            )}
            <span style={chipStyle(!s.is_mandatory)} title={s.is_mandatory ? "Required" : s.is_primary ? "Optional - the service provider can be assigned after booking" : "Optional"}>
              {s.is_primary ? (
                <span style={{ color: "#C2185B" }} role="img" aria-label="service provider step" title="Completes the service">
                  ★
                </span>
              ) : null}
              <span style={{ fontWeight: 600 }}>{s.name || "Untitled step"}</span>
              <span style={{ color: "#6B7280" }}>{whoLabel(s, skills, resourceLabel)}</span>
            </span>
          </React.Fragment>
        ))}
      </div>
      {showLegend && (
        <div style={{ fontSize: "11px", color: "#6B7280", marginTop: "6px" }}>
          → then &nbsp;·&nbsp; + at the same time &nbsp;·&nbsp; dashed = optional &nbsp;·&nbsp; ★ completes the service
        </div>
      )}
    </div>
  );
}
